import React from "react";
import { Box, Button, Text } from "@showitinc/showit-wc";
import MessageUtils from "../../utils/MessageUtils";
import AppConstants from "../../constants/AppConstants";
import uiPrefix from "../../utils/UiPrefixUtils";
import styles from "./ImportCompleteView.module.css";

const ImportCompleteView = ({ designExport, close }) => {
  const designType = designExport.design_type;
  const isSite = AppConstants.DESIGN_TYPE_SITE === designType;
  const renderDesignTypeMessage = () => (
    <Text variant="small">
      Next time you create a new site you will be able to choose this design to start from.
    </Text>
  );

  return (
    <div className={styles["import-success-wrapper"]}>
      <Box d="flex" flex="col" mb="2" justify='center' align='center' className={styles["import-success-content"]}>
        <Box mb="2">
          <Text variant="title-hero" className={styles["heading-text"]}>{MessageUtils.getSuccessExpression()}!</Text>
        </Box>
        <Box mb="2">
          <Text variant="subtitle">This design was successfully added to your library. 
          {isSite ? renderDesignTypeMessage() : null}</Text>
        </Box>
      </Box>
      <Box className={styles["footer-button-wrapper"]}>
        <Button
          variant="outline"
          data-e2e={uiPrefix("modal-close-btn")}
          className={uiPrefix("modal-close-btn")}
          onClick={close}
        >
          Close
        </Button>
      </Box>
    </div>
  );
};

export default ImportCompleteView;
